import { useTranslation } from 'react-i18next';
import BasicSelectInput from '@shared/ui/forms/inputs/BasicSelectInput';
import { useNewMemberDialog } from '@utils/dialogs-hooks';

export default function TeamleadPicker({
  control,
  errors,
  name,
  teamLeads,
  currentTeamLead,
}) {
  const { t } = useTranslation();
  const { openNewMemberDialog } = useNewMemberDialog();

  const hasCurrentTeamLead =
    Boolean(currentTeamLead?.id) &&
    !teamLeads.some((teamLead) => teamLead.id === currentTeamLead.id);

  return (
    <BasicSelectInput
      control={control}
      name={name}
      label={t('team_lead')}
      data={hasCurrentTeamLead ? [currentTeamLead, ...teamLeads] : teamLeads}
      onButtonClick={() => openNewMemberDialog(null)}
      placeholder={t('Administrator')}
      icon="user-input"
      searchable
      error={
        errors?.teamLead_id || errors?.teamlead_transfer?.new_teamlead_user_id
      }
    />
  );
}
